<div class="modal mt-5" [class.show]="isVisible" [style.display]="isVisible ? 'block' : 'none'" tabindex="-1"
     role="dialog">
    <div class="modal-dialog modal-lg" role="document" style="max-height: 90vh;">
        <div class="modal-content" *ngIf="selectedTag" style="max-height: 90vh; display: flex; flex-direction: column;">
            <div class="modal-header">
                <h5 class="modal-title">{{ selectedTag.id === 0 ? 'New Tag' : 'Edit Tag' }}</h5>
                <button type="button" class="close" (click)="onCancel()">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body" style="overflow: hidden; flex: 1; display: flex; gap: 20px;">
                <!-- Left Column: Tag Inputs -->
                <div style="flex: 1; overflow-y: auto;">
                    <div class="form-group">
                        <label>System Type</label>
                        <select class="form-control" [(ngModel)]="selectedTag.systemTypeId">
                            <option [ngValue]="null">-- Select System Type --</option>
                            <option *ngFor="let systemType of filteredSystemTypes" [ngValue]="systemType.id">
                                {{ systemType.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="selectedTag.name"
                               placeholder="Enter tag name"/>
                    </div>
                    <div class="form-group">
                        <label>Description</label>
                        <textarea class="form-control" [(ngModel)]="selectedTag.description" placeholder="Enter description"
                                  rows="3"></textarea>
                    </div>
                    <div class="form-group">
                        <label>Data Type</label>
                        <select
                                class="form-control"
                                [(ngModel)]="selectedTag.dataType">
                            <option [ngValue]="null">-- Select Data Type --</option>
                            <option *ngFor="let option of dataTypeOptions" [ngValue]="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Default Value</label>
                        <app-dynamic-value-input
                                [dataType]="selectedTag.dataType"
                                [defaultValue]="selectedTag.defaultValue"
                                [(ngModel)]="selectedTag.defaultValue"
                                [mode]="'input'"
                                placeholder="Enter default value (comma-separated for dropdown options)">
                        </app-dynamic-value-input>
                    </div>
                </div>

                <!-- Right Column: Device Types -->
                <div style="flex: 1; min-width: 250px; display: flex; flex-direction: column;">
                    <label style="flex-shrink: 0;">Device Types</label>
                    <input 
                        type="text" 
                        class="form-control mb-2" 
                        [(ngModel)]="deviceTypeSearchText" 
                        placeholder="Search device types..."
                        style="flex-shrink: 0;"
                    />
                    <div class="border rounded p-2" style="flex: 1; overflow-y: auto;">
                        <div *ngIf="sortedAndFilteredDeviceTypes?.length === 0" class="text-muted text-center py-2">
                            No device types available
                        </div>
                        <div *ngFor="let deviceType of sortedAndFilteredDeviceTypes" class="form-check">
                            <input 
                                type="checkbox" 
                                class="form-check-input"
                                [id]="'deviceType_' + deviceType.id"
                                [checked]="isDeviceTypeSelected(deviceType.id)"
                                (change)="onDeviceTypeChange(deviceType.id, $event)"
                            />
                            <label class="form-check-label" [for]="'deviceType_' + deviceType.id">
                                {{ deviceType.name }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="onSave()">Save</button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop" [class.show]="isVisible" *ngIf="isVisible"></div>

